const { __, __x, __nx, __N } = JIX.Gettext;

export default {
    bannerHeadingTag: () =>
        __('Nyhed'),
    bannerHeading: () =>
        __('Få hjælp til din ansøgning med AI Apply Helper'),
    bannerParagraph: () =>
        __('Det er tidskrævende og trivielt at skrive en ansøgning. AI Apply Helper kan have et udkast klar til dig på få minutter!'),
    bannerLink: () =>
        __('Skriv min ansøgning'),
};

